<template>
    <div class="choose">
        <b-container fluid>
            <b-row>
                <b-col>
                    <div class="production"></div>
                    <div class="textnf"></div>
                    <b-form v-on:submit.prevent class="productionform">
                        <b-button @click="production" type="submit" variant="primary">Production</b-button>
                    </b-form>
                </b-col>
                <b-col>
                    <div class="installation"></div>
                    <b-form v-on:submit.prevent class="installationform">
                        <b-button @click="installation" type="submit" variant="primary">Installation</b-button>
                    </b-form>
                </b-col>
                <b-col>
                    <div class="barnf"></div>
                    <div class="servicecare"></div>
                    <b-form v-on:submit.prevent class="servicecareform">
                        <b-button @click="servicecare" type="submit" variant="primary">Service & Care</b-button>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'Choose',
    components: {

    },
    data() {
        return {
            section: null,
        }
    },
    beforeMount() {
        this.$store.commit('setSection', false)
    },
    methods: {
        production() {
            this.$store.commit('setSection', 'production')
            this.$router.push('/pimymachines')
        },
        installation() {
            this.$store.commit('setSection', 'installation')
            this.$router.push('/pimymachines')
        },
        servicecare() {
            console.log("servicecare")
            this.$store.commit('setSection', 'servicecare')
            console.log("servicecare", this.$store.getters.section)
            this.$router.push('/scmachines')
        }
    }
}
</script>
<style scoped>
form button {
    background-color: #9a240d !important;
    border-color: #9a240d !important;
}
form button:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
form button:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.choose div {
    margin-top: 100px;
    margin-bottom: 100px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    height: 30vh;
}
div.production {
    background-image: url('/images/production_nf.png');
}

div.installation {
    background-image: url('/images/installation_nf.png');
}

div.servicecare {
    background-image: url('/images/servicecare_nf.png');
}
div.textnf {
    background-image: url('/images/text_nf.png');
    position: absolute;
    top: -80px;
    left: calc(500 / 1920 * 100vw - 30px);
    width: 260px;
    height: 555px !important;
}
div.barnf {
    background-image: url('/images/bar_nf.png');
    position: absolute;
    top: -80px;
    left: -30px;
    width: 60px;
    height: 555px !important;
}
</style>